<template>
  <div class="settlement-amount col-md-12 flex mt-4">
    <div class="row">
      <div class="col-lg-2 col-sm-4 mb-3">
        <div v-if="$_can('claims.settlement-amounts.store')" class="select-wrap">
          <label>Office</label>
          <input v-model="officeSettlementAmount.amount" type="text" class="form-control" @change="createOrUpdateAmount(officeSettlementAmount)" />
        </div>
        <span v-else>
          <span>Office</span>
          <span>
            {{ officeSettlementAmount.amount }}
          </span>
        </span>
      </div>
      <div class="col-lg-10 col-sm-8 mb-3 settlement-approve flex align-items-center"
           :class="settlementStatusDeclineClass(3)"
      >
        <div class="settlement-approve-row col-md-12 flex align-items-center" :class="settlementStatusClass(1)">
          <span v-if="!settlementTypeOffice">Amount wasn't entered.</span>
          <div v-if="settlementNotSent(3)" class="flex w-full justify-content-between align-items-center">
            <div>Request not sent.</div>
            <button
              v-if="$_can('claims.settlement-amounts.store')"
              class="btn btn-outline-secondary btn-sm" @click="sendOfficeAuth"
              :class="loadingButtonOffice ? 'running' : ''" :disabled="disabledButtonOffice"
            >
              Request office auth
              <div v-if="loadingButtonOffice" class="ld ld-ball ld-flip" />
            </button>
          </div>
          <span v-if="settlementSent(3)" class="flex w-full justify-content-between align-items-center">
            <span>Requested for <span class="sett-amount">${{ settlementAmount(3) }}</span></span>
            <span>
              <button v-if="$_can('claims.settlement-amounts.office.approve')" class="btn btn-decline btn-sm" @click="toggleOfficeDeclineModal">Decline</button>
              <button v-if="$_can('claims.settlement-amounts.office.approve')"
                      class="btn btn-approve btn-sm"
                      @click="updateSettlementAmount(officeSettlementAmount, 3)"
              >Approve</button></span>
          </span>
          <span v-if="settlementApproved(3)">
            <i class="fa fa-check-circle approved-icon" />
            Office price has been approved -
            <span class="sett-amount">${{ settlementAmount(3) }}</span>
          </span>
          <span v-if="settlementDeclined(3)" class="w-full pa-8px">
            <span class="flex w-full justify-content-between align-items-center">
              <span>
                <i class="fa fa-times-circle denied-icon" />
                Office price denied -
                <span class="sett-amount">${{ settlementAmount(3) }}</span>
              </span>
              <!--<span><button class="btn btn-outline-secondary btn-sm">Request settlement auth</button></span>-->
            </span>
            <hr class="line-decline" v-if="settlementNote(3)" />
            <div>
              <read-more v-if="settlementNote(3)" class="show-more" more-str="Show more" :text="settlementNote(3)"
                         less-str="Show less" :max-chars="200"
              />
            </div>
          </span>
        </div>
      </div>
      <div class="col-lg-2 col-sm-4 mb-3">
        <div v-if="$_can('claims.settlement-amounts.store')" class="select-wrap">
          <label>Subco</label>
          <input v-model="subcoSettlementAmount.amount" type="text" class="form-control" @change="createOrUpdateAmount(subcoSettlementAmount)" />
        </div>
        <span v-else>
          <span>Subco</span>
          <span>
            {{ subcoSettlementAmount.amount }}
          </span>
        </span>
      </div>
      <div class="col-lg-10 col-sm-8 mb-3 settlement-approve flex align-items-center"
           :class="settlementStatusDeclineClass(2)"
      >
        <div class="settlement-approve-row col-md-12 flex align-items-center" :class="settlementStatusClass(2)">
          <span v-if="!settlementTypeSubco">Amount wasn't entered.</span>
          <div v-if="settlementNotSent(2)" class="flex w-full justify-content-between align-items-center">
            <div>Request not sent.</div>
            <button
              v-if="$_can('claims.settlement-amounts.store')"
              class="btn btn-outline-secondary btn-sm" @click="sendSubcoAuth"
              :class="loadingButtonSubco ? 'running' : ''" :disabled="disabledButtonSubco"
            >
              Request subco auth
              <div v-if="loadingButtonSubco" class="ld ld-ball ld-flip" />
            </button>
          </div>
          <span v-if="settlementSent(2)" class="flex w-full justify-content-between align-items-center">
            <span>Requested for <span class="sett-amount">${{ settlementAmount(2) }}</span></span>
            <span>
              <button v-if="$_can('claims.settlement-amounts.subco.approve')" class="btn btn-decline btn-sm" @click="toggleSubcoDeclineModal">Decline</button>
              <button v-if="$_can('claims.settlement-amounts.subco.approve')"
                      class="btn btn-approve btn-sm"
                      @click="updateSettlementAmount(subcoSettlementAmount, 3)"
              >Approve</button></span>
          </span>
          <span v-if="settlementApproved(2)">
            <i class="fa fa-check-circle approved-icon" />
            Subco price has been approved -
            <span class="sett-amount">${{ settlementAmount(2) }}</span>
          </span>
          <span v-if="settlementDeclined(2)" class="w-full pa-8px">
            <span class="flex w-full justify-content-between align-items-center">
              <span>
                <i class="fa fa-times-circle denied-icon" />
                Subco price denied -
                <span class="sett-amount">${{ settlementAmount(2) }}</span>
              </span>
              <!--<span><button class="btn btn-outline-secondary btn-sm">Request settlement auth</button></span>-->
            </span>
            <hr class="line-decline" v-if="settlementNote(2)" />
            <div>
              <read-more v-if="settlementNote(2)" class="show-more" more-str="Show more" :text="settlementNote(2)"
                         less-str="Show less" :max-chars="200"
              />
            </div>
          </span>
        </div>
      </div>
      <div class="col-md-12">
        <hr class="line" />
      </div>
      <div class="col-md-12 flex justify-content-md-end">
        <span class="sett-ammount-desc flex align-items-center">Approved amount: </span> <span class="sett-amount-sum" v-if="!loader"> ${{ claim.settlement_amount }} </span>
        <div v-if="loader" class="lds-ellipsis">
          <div />
          <div />
          <div />
        </div>
      </div>
      <div class="col-md-12 flex justify-content-md-end">
        <span v-if="!manualOverride && $_can('claims.settlement.override') && !claim.settlement_email_sent" @click="toggleMailSentOverrideModal">
          <i class="fa fa-envelope mail-envelope-icon" />
        </span>
        <Tooltip :config="{ placement: 'left' }">
          <div
            slot-scope="{ isOpen, open, close }"
            @mouseover="open"
            @mouseleave="close"
          >
            <button
              data-trigger
              class="btn btn-primary"
              @click="toggleSidebar"
              :disabled="!canSendEmail"
            >
              <span>
                Email customer with offer
              </span>
            </button>
            <div
              v-show="isOpen && !canSendEmail"
              data-popper
              class="p-2 w-48 text-sm bg-white text-white shadow-lg z2 popup-border tooltip-overflow"
            >
              <div x-arrow />
              <div
                class="d-flex flex-column align-items-center justify-content-center"
              >
                <div class="text-dark popup-text">
                  Cannot send the offer to customer
                  <br />
                  until settlement amount was approved.
                </div>
              </div>
            </div>
          </div>
        </Tooltip>
      </div>
      <div v-if="claim.settlement_email_sent" class="col-md-12 mt-2 flex justify-content-md-end">
        <div class="flex flex-column" v-if="claim.settlement_customer_approved === 1">
          <span class="accepted">Customer accepted settlement amount of ${{ claim.settlement_amount_accepted }}.</span>
          <span v-if="claim.settlement_note" class="see-note flex justify-content-end pointer" data-toggle="modal" data-target="#noteModal">Show note</span>
        </div>
        <div class="flex flex-column" v-else-if="claim.settlement_customer_approved === 0">
          <span class="declined">Customer declined settlement amount of ${{ claim.settlement_amount_accepted }}.</span>
          <span v-if="claim.settlement_note" class="see-note flex justify-content-end pointer" data-toggle="modal" data-target="#noteModal">Show note</span>
        </div>
        <div v-else-if="claim.settlement_email_sent && manualOverride">
          <span>Settlement offer sent manually to customer.</span>
        </div>
        <div v-else>
          <span>Settlement offer of ${{ claim.settlement_amount_sent }} emailed to customer.</span>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showEmailModal">
        <send-claim-email
          class="sidebar-right"
          @cancel="toggleSidebar()"
          :job="claim.job"
          :type-id="3"
          @update="$emit('update')"
        />
      </div>
    </transition>

    <!-- Customer note modal -->
    <div class="modal fade" id="noteModal" tabindex="-1" role="dialog" aria-labelledby="noteModalLongTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Customer note</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{ claim.settlement_note }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!--  Decline modal for office  -->
    <decline-settlement-amount
      v-if="officeDeclineModal"
      @close="toggleOfficeDeclineModal"
      :settlement-amount="officeSettlementAmount"
      :errors="errors"
      @update="updateSettlementAmount(officeSettlementAmount, 4)"
    />
    <!--  Decline modal for subco  -->
    <decline-settlement-amount
      v-if="subcoDeclineModal"
      @close="toggleSubcoDeclineModal"
      :settlement-amount="subcoSettlementAmount"
      :errors="errors"
      @update="updateSettlementAmount(subcoSettlementAmount, 4)"
    />
    <!-- Settlement sent override modal -->
    <modal v-if="settlementOverride"
           @close="settlementOverride = false"
           :size="'modal-small'"
           :close-strict="true"
    >
      <div slot="header">
        <div class="row">
          <div class="col-10" />
        </div>
      </div>
      <div slot="body">
        <div class="row text-center mt-3 p-4">
          <h4>This action will mark that the settlement email was sent to the customer. Please confirm to proceed.</h4>
        </div>
      </div>
      <div slot="footer">
        <div class="row mb-2 mt-4">
          <div class="col text-center">
            <button type="button" class="btn btn-secondary" @click="settlementOverride = false">
              Cancel
            </button>
            <button class="btn btn-primary ld-ext-right"
                    type="button"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
                    @click="overrideSettlement"
            >
              Yes, confirm
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapActions, mapGetters, mapState } from 'vuex';
import SendClaimEmail from './Modals/SendClaimEmail';
import DeclineSettlementAmount from './Modals/DeclineSettlementAmount';
import Tooltip from '../Tooltip';
import Modal from '../Modal';
import Errors from '../../classes/Errors';

export default {
  name: 'ClaimSettlementAmount',
  components: {
    DeclineSettlementAmount,
    SendClaimEmail,
    Tooltip,
    Modal,
  },
  props: {
    claim: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      errors: new Errors(),
      officeSettlementAmount: {
        amount: null,
        claim_id: null,
        discount_unit_type_id: 1,
        id: null,
        job_id: this.claim.job_id,
        name: `Claim ${this.claim.id} office settlement amount`,
        type_id: 3,
      },
      subcoSettlementAmount: {
        amount: null,
        claim_id: null,
        discount_unit_type_id: 1,
        id: null,
        job_id: this.claim.job_id,
        name: `Claim ${this.claim.id} carrier settlement amount`,
        type_id: 2,
      },
      showEmailModal: false,
      loadingButtonOffice: false,
      loadingButtonSubco: false,
      disabledButtonOffice: false,
      disabledButtonSubco: false,
      officeDeclineModal: false,
      subcoDeclineModal: false,
      settlementOverride: false,
      manualOverride: false,
      loadingButton: false,
      buttonDisabled: false,
      loader: false,
      showTooltip: false,
    };
  },
  computed: {
    ...mapState({
      settlementAmounts: state => state.claims.settlementAmounts.data,
    }),
    ...mapGetters(['settlementTypeSubco', 'settlementTypeOffice']),
    canSendEmail() {
      return this.settlementApproved(3) || this.settlementApproved(2);
    },
  },
  watch: {
    settlementTypeOffice() {
      if (this.settlementTypeOffice) this.officeSettlementAmount = this.settlementTypeOffice;
      return '';
    },
    settlementTypeSubco() {
      if (this.settlementTypeSubco) this.subcoSettlementAmount = this.settlementTypeSubco;
      return '';
    },
    claim() {
      this.loader = false;
    },
  },
  created() {
    this.getSettlementAmounts(this.$route.params.id);
  },
  methods: {
    ...mapActions(['getSettlementAmounts']),
    toggleMailSentOverrideModal() {
      if (this.$_can('claims.settlement.override'))
        this.settlementOverride = !this.settlementOverride;
    },
    toggleSubcoDeclineModal() {
      this.clearErrors();
      this.subcoDeclineModal = !this.subcoDeclineModal;
    },
    toggleOfficeDeclineModal() {
      this.clearErrors();
      this.officeDeclineModal = !this.officeDeclineModal;
    },
    toggleSidebar() {
      this.showEmailModal = !this.showEmailModal;
    },
    unsendSettlement() {
      axios
        .patch(`/claims/${this.$route.params.id}`, {
          settlement_email_sent: false,
          skip_log: true,
        })
        .then(res => {
          this.claim.settlement_email_sent = res.data.data.settlement_email_sent;
          this.manualOverride = false;
        });
    },
    overrideSettlement() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      axios
        .patch(`/claims/${this.$route.params.id}`, {
          settlement_email_sent: true,
        })
        .then(res => {
          this.claim.settlement_email_sent = res.data.data.settlement_email_sent;
          this.settlementOverride = false;
          this.manualOverride = true;
          this.$emit('update');
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    sendOfficeAuth() {
      this.loadingButtonOffice = true;
      this.disabledButtonOffice = true;
      axios
        .post(
          `/claims/${this.officeSettlementAmount.claim_id}/settlement-amounts/${
            this.officeSettlementAmount.id
          }/send`,
          {},
        )
        .then(() => {
          toastr.success('Email for price authorization has been sent');
          this.officeSettlementAmount.settlement_status_id = 2;
          this.$emit('update');
        })
        .catch(err => {
          toastr.error(err);
        })
        .finally(() => {
          this.loadingButtonOffice = false;
          this.disabledButtonOffice = false;
        });
    },
    sendSubcoAuth() {
      this.loadingButtonSubco = true;
      this.disabledButtonSubco = true;
      axios
        .post(
          `/claims/${this.subcoSettlementAmount.claim_id}/settlement-amounts/${
            this.subcoSettlementAmount.id
          }/send`,
          {},
        )
        .then(() => {
          toastr.success('Email for price authorization has been sent');
          this.subcoSettlementAmount.settlement_status_id = 2;
          this.$emit('update');
        })
        .catch(err => {
          toastr.error(err);
        })
        .finally(() => {
          this.loadingButtonSubco = false;
          this.disabledButtonSubco = false;
        });
    },
    settlementStatusDeclineClass(type) {
      if (
        this.getSettlementAmount(type) &&
        this.getSettlementAmount(type).settlement_status_id === 4
      ) {
        return 'settlement-decline';
      }
      return '';
    },
    settlementStatusClass(type) {
      if (
        this.getSettlementAmount(type) &&
        this.getSettlementAmount(type).settlement_status_id === 3
      ) {
        return 'settlement-approve-green';
      }
      if (
        this.getSettlementAmount(type) &&
        this.getSettlementAmount(type).settlement_status_id === 4
      ) {
        return 'settlement-approve-red';
      }
      return '';
    },
    settlementNote(type) {
      return this.getSettlementAmount(type).note;
    },
    settlementAmount(type) {
      return this.getSettlementAmount(type).amount;
    },
    settlementNotSent(type) {
      return (
        this.getSettlementAmount(type) && this.getSettlementAmount(type).settlement_status_id === 1
      );
    },
    settlementSent(type) {
      return (
        this.getSettlementAmount(type) && this.getSettlementAmount(type).settlement_status_id === 2
      );
    },
    settlementApproved(type) {
      return (
        this.getSettlementAmount(type) && this.getSettlementAmount(type).settlement_status_id === 3
      );
    },
    settlementDeclined(type) {
      return (
        this.getSettlementAmount(type) && this.getSettlementAmount(type).settlement_status_id === 4
      );
    },
    getSettlementAmount(type) {
      if (this.settlementAmounts) {
        return this.settlementAmounts.filter(sa => sa.type_id === type)[0];
      }
      return '';
    },
    createOrUpdateAmount(settlementAmount) {
      const amount = this.getSettlementAmount(settlementAmount.type_id);
      if (amount) {
        this.updateSettlementAmount(settlementAmount, 1);
        this.unsendSettlement();
      } else {
        this.createSettlementAmount(settlementAmount);
        this.unsendSettlement();
      }
    },
    createSettlementAmount(settlementAmount) {
      axios
        .post(`/claims/${this.$route.params.id}/settlement-amounts`, settlementAmount)
        .then(() => {
          toastr.success('Settlement amount created successfully');
          this.getSettlementAmounts(this.$route.params.id);
          this.$emit('update');
        })
        .catch(err => {
          toastr.error(err);
        });
    },
    updateSettlementAmount(settlementAmount, statusId = null) {
      const updateAmount = Object.assign({}, settlementAmount);
      this.loader = true;
      if (statusId) {
        updateAmount.settlement_status_id = statusId;
      }
      axios
        .patch(
          `claims/${this.$route.params.id}/settlement-amounts/${updateAmount.id}`,
          updateAmount,
        )
        .then(() => {
          toastr.success('Settlement amount updated successfully');
          this.officeSettlementAmount = {
            amount: null,
            claim_id: null,
            discount_unit_type_id: 1,
            id: null,
            job_id: this.claim.job_id,
            name: `Claim ${this.claim.id} office settlement amount`,
            type_id: 3,
          };
          this.subcoSettlementAmount = {
            amount: null,
            claim_id: null,
            discount_unit_type_id: 1,
            id: null,
            job_id: this.claim.job_id,
            name: `Claim ${this.claim.id} carrier settlement amount`,
            type_id: 2,
          };
          this.getSettlementAmounts(this.$route.params.id);
          this.$emit('update');
          this.clearErrors();
          if (this.subcoDeclineModal || this.officeDeclineModal) {
            this.subcoDeclineModal = false;
            this.officeDeclineModal = false;
          }
        })
        .catch(err => {
          settlementAmount = updateAmount;
          this.errors.record(err.response.data.error);
          if (!this.subcoDeclineModal && !this.officeDeclineModal) {
            toastr.error(err);
          }
        });
    },
    clearErrors() {
      this.errors.clear();
    },
  },
};
</script>
<style scoped>
.pa-8px {
  padding: 8px;
}

.settlement-amount {
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(43, 59, 93, 0.15);
  padding: 20px;
}

.line {
  border: solid 1px #e0e5ea;
  margin: 18px 0 22px 0;
}

.line-decline {
  border: solid 1px #e0e5ea;
  margin: 7px 0 15px 0;
}

.btn-primary {
  margin-top: 12px;
}

.btn-secondary {
  margin-top: 12px;
}

.btn-decline {
  border-radius: 4px;
  border: solid 2px rgba(255, 0, 0, 0.3);
  background-color: #fff;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #ff0000;
  margin-right: 8px;
}

.btn-decline:hover {
  background: #ff0000;
  color: white;
}

.btn-approve {
  border-radius: 4px;
  border: solid 2px rgba(45, 179, 0, 0.3);
  background: #fff;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #2db300;
}

.btn-approve:hover {
  background: #2db300;
  color: white;
}

.settlement-req,
.settlement-approve {
  max-height: 52px;
  font-size: 15px;
}

.settlement-req-row,
.settlement-approve-row {
  height: 100%;
  width: 100%;
  border: solid 1px #e0e5ea;
}

.settlement-approve-green {
  height: 100%;
  width: 100%;
  border: solid 1px green !important;
}

.settlement-approve-red {
  height: 100%;
  width: 100%;
  border: solid 1px red !important;
}

.settlement-decline {
  max-height: 100%;
}

.sett-ammount-desc {
  font-size: 13px;
  opacity: 0.7;
  color: #808d98;
  padding-right: 12px;
}

.sett-amount {
  color: #212529;
  font-weight: 500;
}

.sett-amount-sum {
  font-size: 20px;
  color: #4c5669;
}

.declined {
  color: red;
  padding-top: 5px;
}

.accepted {
  color: #2eb300;
  padding-top: 5px;
}
/* loader */

.lds-ellipsis {
  display: flex;
  height: 15px;
  padding-top: 11px;
}

.lds-ellipsis div {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #e0e5ea;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #e0e5ea;
  }
}

.mail-envelope-icon {
  font-size: 16px;
  color: #2962ff;
  padding-right: 10px;
  padding-top: 25px;
  cursor: pointer;
}

.tooltip-overflow {
  z-index: 1000;
}

.see-note {
  color: #2962ff;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.see-note:hover {
  opacity: 0.7;
}
#noteModal .modal-header,
#noteModal .modal-footer {
  border: none;
}
#noteModal .modal-body {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/ClaimSettlementAmount.vue